export { default } from './prospect-details-container';
